











import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextRender from "./textAndImage/TextRender.vue";
import ImageRender from "./image/ImageRender.vue";
import VideoRender from "./video/VideoRender.vue";
import { NewsRenderModel } from "@/services/news/types";

@Component({
    components: {
        textRender: TextRender,
        imageRender: ImageRender,
        videoRender: VideoRender
    },
    filters: {
        render(value: string) {
            return value.concat("Render");
        }
    }
})
export default class SingleNewsRender extends Vue {
    @Prop() private newsRenderModel!: NewsRenderModel;

    currentNewsId = "" as string;

    @Watch("newsRenderModel")
    onPropertyChanged() {
        if (this.newsRenderModel) {
            this.currentNewsId = this.newsRenderModel.id;
        }
    }

    // lifecycle hooks
    created() {
        this.currentNewsId = this.newsRenderModel.id;
    }

    get renderModel() {
        return this.newsRenderModel;
    }
}
